/* eslint-disable @stylistic/max-len */
import style from './play.module.css';

const Play = () => {
  return (
    <svg
      fill="none"
      height="85"
      viewBox="0 0 84 85"
      width="84"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2903_6114)">
        <path
          className={style.playIconCircle}
          d="M41.82 85C64.9165 85 83.64 65.9721 83.64 42.5C83.64 19.0279 64.9165 0 41.82 0C18.7235 0 0 19.0279 0 42.5C0 65.9721 18.7235 85 41.82 85Z"
        />
        <path
          d="M32.7891 25.72V59.28L62.0291 42.5L32.7891 25.72Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2903_6114">
          <rect
            fill="white"
            height="85"
            width="83.63"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Play;
